module.exports = __webpack_public_path__ + "img/上海地产.7097fc34.png";